/* Action Types */
export const REDIRECT = 'REDIRECT';

/* Action Creators */
export const redirect = url => {
  return { type: REDIRECT, url };
}



// WEBPACK FOOTER //
// ./src/ducks/Application.js